import { api } from './client';

export type AttachmentOwner = 'organization' | 'ticket' | 'installation' | 'note';

export interface Attachment {
  id: string;
  owner_type: AttachmentOwner;
  owner_id: string;
  filename: string;
  content_type: string | null;
  size_bytes: number;
  category: string | null;
  description: string | null;
  uploaded_by_id: string | null;
  uploaded_by_name: string | null;
  created_at: string;
}

export const attachmentsApi = {
  list: (owner_type: AttachmentOwner, owner_id: string) =>
    api.get<Attachment[]>('/api/v1/attachments', { params: { owner_type, owner_id } }).then(r => r.data),

  upload: (owner_type: AttachmentOwner, owner_id: string, file: File, category?: string, description?: string) => {
    const fd = new FormData();
    fd.append('owner_type', owner_type);
    fd.append('owner_id', owner_id);
    fd.append('file', file);
    if (category) fd.append('category', category);
    if (description) fd.append('description', description);
    return api.post<Attachment>('/api/v1/attachments', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(r => r.data);
  },

  remove: (id: string) =>
    api.delete(`/api/v1/attachments/${id}`),

  // URL для скачивания (Authorization подставит interceptor через axios → fetch — нет.
  // Мы вызываем через api.get с responseType=blob и инициируем браузерное скачивание).
  download: async (att: Attachment) => {
    const r = await api.get(`/api/v1/attachments/${att.id}/download`, { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([r.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = att.filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  },
};

export const formatBytes = (n: number): string => {
  if (n < 1024) return `${n} Б`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} КБ`;
  return `${(n / 1024 / 1024).toFixed(2)} МБ`;
};

export const ORG_CATEGORIES = ['Договор', 'Анкета', 'Доп. соглашение', 'Акт', 'Прочее'];

// Категории для документов уровня инсталляции (паспорт системы, схема сети и т.д.)
export const INSTALLATION_CATEGORIES = [
  'Паспорт системы',
  'Схема сети',
  'Конфигурация',
  'Лицензия',
  'Прочее',
];
